/** Add the protocol customers usually leave out; the server validates the address. */
export function normalizeWebsiteInput(value: string): string {
  const address = value.trim();
  if (!address || /^[a-z][a-z\d+.-]*:/i.test(address) || /^[/?#]/.test(address) || /[\s\\@]/.test(address)) return address;
  return `https://${address}`;
}
